import { render, staticRenderFns } from "./filing-type.vue?vue&type=template&id=5666be66&scoped=true&"
import script from "./filing-type.vue?vue&type=script&lang=ts&"
export * from "./filing-type.vue?vue&type=script&lang=ts&"
import style0 from "./filing-type.vue?vue&type=style&index=0&id=5666be66&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5666be66",
  null
  
)

export default component.exports